<template>
  <external-subgroup-context-picker
    class="external"
    v-if="!isInternalUser"
  />
  <internal-subgroup-context-picker
    v-else
  />
</template>

<script>
  import { mapGetters } from 'vuex'
  import InternalSubgroupContextPicker from './SubGroupContextPicker/Internal'
  import ExternalSubgroupContextPicker from './SubGroupContextPicker/External'

  export default {
    components: {
      InternalSubgroupContextPicker,
      ExternalSubgroupContextPicker
    },
    computed: {
      ...mapGetters(['isInternalUser'])
    }
  }
</script>
